require('select2/dist/js/select2.full.js');
require('backbone.marionette');
require('select2/src/scss/core.scss');
require('./dropdown-list-inner.scss');
require('select2/src/scss/core.scss');
var DropdownListInner = Marionette.ItemView.extend({
    _currentSelectedModel: null,
    template: require('./dropdown-list.tpl'),
    className: 'tl-dropdown-list-inner',
    ui: {
        select: 'select'
    },
    events: {
        'select2:unselecting': function () {
            this._currentSelectedModel = null;

            if (this.model && this.options.modelValueAttr) {
                this.model.set(this.options.modelValueAttr, null);
            }

            this.trigger('selected', null);
            if (this.options.onSelectedCallback) {
                this.options.onSelectedCallback(
                    null,
                    null
                );
            }
        },
        'select2:select select': function (evtObj) {
            if (evtObj.params.data.model) {
                this._currentSelectedModel = evtObj.params.data.model;
            } else {
                this._currentSelectedModel = this._getModelByValueAttrValue(evtObj.params.data.id);
            }

            if (this.model && this.options.modelValueAttr) {
                this.model.set(this.options.modelValueAttr, evtObj.params.data.id);
            }

            this.trigger('selected', evtObj.params.data.id);
            if (this.options.onSelectedCallback) {
                this.options.onSelectedCallback(
                    evtObj.params.data.id,
                    this._currentSelectedModel
                );
            }
        },
        'select2:selecting': function (e) {
            var selectingValue = e.params.args.data.id;
            // preventSelection is a way for callers to prevent a selection
            // from being made but still react to it by listening to the
            // "clicked" event
            if (this.options.preventSelection &&
                this.options.preventSelection(selectingValue))
            {
                e.preventDefault();
                this.trigger('clicked', selectingValue);
                this.ui.select.select2('close');
            }
        }
    },
    _getModelByValueAttrValue: function (val) {
        var self = this;
        return self.collection.find(function (item) {
            return item.get(self.options.valueAttr) == val;
        });
    },
    val: function (val) {
        if (_.isUndefined(val)) {
            return this.ui.select.val();
        } else {
            this.ui.select.val(val).trigger('change');
        }
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                dropdownParent: null,
                customClassName: '',
                closeOnSelect: true,
                dropdownCssClass: '',
                suppressSearch: false,
                minimumResultsForSearch: 5,
                placeholder: undefined,
                allowClear: false,
                preventSelection: null,
                width: undefined,
                modelAttr: 'dummy',
                modelValueAttr: undefined,
                displayAttr: undefined,
                valueAttr: undefined,
                iconURLAttr: undefined,
                openAndFocused: false,
                inputFocused: true,
                noIconURLAttr: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/2000px-No_image_available.svg.png',
                disabled: false,
                initialValue: undefined,
                onSelectedCallback: undefined,
                minimumInputLength: 0,
                formatResult: function (model, options) {
                    var template;
                    var templateVars = {
                        name: model.get(options.displayAttr)
                    };
                    if (options.iconURLAttr) {
                        template = _.template(
                            '<div class="tl-wrapper tl-show-icon"><div class="tl-icon-wrapper"><img src="<%= thumbnail %>"></div><div  class="tl-text-wrapper"><%= name %></div></div>'
                        );
                        return $(template(
                            _.extend(
                                templateVars,
                                { thumbnail: model.get(options.iconURLAttr) || options.noIconURLAttr }
                            )
                        ));
                    } else {
                        template = _.template(
                            '<div class="tl-wrapper"><div class="tl-text-wrapper"><%= name %></div></div>'
                        );
                        return $(template(templateVars));
                    }
                }
            }
        );
    },
    onDestroy: function () {
        if (this.ui.select.data('select2')) {
            this.ui.select.select2('destroy');
        }
    },
    onShow: function () {
        if (this.options.initialValue) {
            this.val(this.options.initialValue);
        }
    },
    _maybeSetSelectedItem: function () {
      var self = this;
        if (!self.model ||
            !self.options.modelValueAttr ||
            !self.model.get(self.options.modelValueAttr))
        {
            return;
        }
        function appendSelectedOption (selectedModel) {
            var selectedOption = new Option(
                selectedModel.get(self.options.displayAttr),
                selectedModel.get(self.options.valueAttr),
                true,
                true
            );
            self.ui.select.append(selectedOption).trigger('change');

            self.ui.select.trigger({
                type: 'select2:select',
                params: {
                    data: _.extend(selectedModel.toJSON(), { model: selectedModel })
                }
            });
        }
        var selected = self.collection.get(self.model.get(self.options.modelValueAttr));
        if (selected) {
            appendSelectedOption(selected);
        } else if (self._currentSelectedModel &&
            self._currentSelectedModel.get(self.options.valueAttr) == self.model.get(self.options.modelValueAttr))
        {
            appendSelectedOption(self._currentSelectedModel);
        } else {
            if (self.options.provideSingleListItemById) {
                self._setPlaceholderText('Loading...');
                self.options.provideSingleListItemById(
                    self.model.get(self.options.modelValueAttr)
                ).then(function (providedModel) {
                    appendSelectedOption(providedModel);
                }).fail(function () {
                    console.warn('dropdown-list-inner: failed to fetch selected item');
                }).always(function () {
                    if (self.options.placeholder) {
                        self._setPlaceholderText(self.options.placeholder);
                    } else {
                        self._setPlaceholderText('');
                    }
                });
            } else {
                console.warn('dropdown-list-inner: provideSingleListItemById option was not provided');
            }
        }
    },
    _setPlaceholderText: function (text) {
        this.$el.find('.select2-selection__placeholder').text(text);
    },
    onRender: function () {
        var self = this;

        // Add a special class to the drop down list flyout if
        // this drop down list is a child of a modal to ensure
        // proper z-index.
        self.ui.select.on('select2:open', function () {
            if (self.$el.parents('.modal').length) {
                $('.select2-container.select2-container--open')
                    .addClass('modal-select2-container');
            }
            if (!self.options.inputFocused) {
              $('.select2-search input').prop('focus', 0);
            }
        });

        function formatState (state) {
            if (!state.id) {
                return state.text;
            }
            if (self.options.formatResult) {
                return self.options.formatResult(
                    self._getModelByValueAttrValue(state.id),
                    self.options
                );
            }
            return state.text;
        }

        var select2Options = {
            minimumResultsForSearch:
                self.options.suppressSearch ?
                Infinity :
                self.options.minimumResultsForSearch,
            placeholder: self.options.placeholder,
            allowClear: self.options.allowClear,
            closeOnSelect: self.options.closeOnSelect,
            minimumInputLength: self.options.minimumInputLength,
            inputTooShortMessage: null,
            width: self.options.width,
            dropdownCssClass: 'tl-dropdown-list-inner-select2-container ' + self.options.dropdownCssClass,
            ajax: {
                delay: 250,
                transport: function (params, success, failure) {
                    var page = params.data.page || 1;
                    var remove = page === 1 ? true : false;
                    var $request = self.collection.fetch(
                        {
                            remove: remove,
                            data: {
                                page: page,
                                search_term: params.data.term || ''
                            },
                            success: function (collection, response, options) {

                                if (response) {
                                    var numPages =
                                        parseInt(options.xhr.getResponseHeader('X-WP-TotalPages'), 10);
                                    var processed = {
                                        results: [],
                                        pagination: {}
                                    };
                                    _.each(response, function (item) {
                                        processed.results.push({
                                            id: item[self.options.valueAttr],
                                            text: item[self.options.displayAttr]
                                        });
                                    });
                                    processed.pagination.more = page < numPages;
                                    success(processed);

                                } else {
                                    failure();
                                }
                            }
                    });

                    return $request;
                  }
            },
            dropdownAutoWidth: 'true',
            disabled: self.options.disabled,
            templateResult: formatState
        };

        if (self.options.inputTooShortMessage) {
            select2Options.language = {
                inputTooShort: function () {
                    return self.options.inputTooShortMessage;
                }
            };
        }

        if (self.options.dropdownParent) {
            select2Options.dropdownParent = self.options.dropdownParent;
        }

        self.ui.select.select2(select2Options);

        self._maybeSetSelectedItem();

        self.$el.addClass(self.options.customClassName);

        if (self.options.modelValueAttr) {
            self.$el.attr('name', self.options.modelValueAttr);
        }

        self.ui.select.data('select2').on('results:message', function (evtObj) {
            // Reposition the dropdown when the inputTooShort message is shown as
            // without this the dropdown does not get re-positioned and
            // sits disconnected from the search entry box.
            if (evtObj.message === 'inputTooShort') {
                this.dropdown._positionDropdown();
            }
        });

        if (this.options.openAndFocused) {
          _.delay(function () {
            self.ui.select.select2('open');
            $('.select2-container.select2-container--open')
                .addClass('modal-select2-container');
          }, 100);
        }

    },
    serializeData: function () {
        return {
            options: this.options
        };
    }
});
module.exports = DropdownListInner;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/dropdown-list/dropdown-list-inner.js
 ** module id = 33
 ** module chunks = 1 2 3 4 7 8 12 18 20 21 24 31 34 35 36 37 41 43 47 52 63 64 73 74 75 82 98 99 102
 **/